import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import user from "./modules/user";
import notifications from "./modules/notifications";
import cards from "./modules/cards";
import discount from "./modules/discount";
import tickets from "./modules/tickets";
import requests from "./modules/requests";
import bills from "./modules/bills";
import regions from "./modules/regions";
import orders from "./modules/orders";
import stations from "./modules/stations";
import workorders from "./modules/workorders";
import config from "./modules/config";
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    auth,
    user,
    notifications,
    cards,
    discount,
    tickets,
    requests,
    bills,
    regions,
    orders,
    stations,
    workorders,
    config,
  },
  strict: debug
});